<template>
    <div>
        <div v-if="showModel==='modelBaseinfo'">
            <van-cell-group title="个人公积金基本信息">
                <van-cell v-for="(item, index) in baseinfoList"
                          :key="index"
                          :title="item.title"
                          :value="item.info"
                />
            </van-cell-group>
            <span class="blank"></span>
            <van-cell-group>
                <van-cell v-for="(item, index) in baseinfoList2"
                          :key="index"
                          :title="item.title"
                          :value="item.info"
                />
            </van-cell-group>
            <van-button type="default" size="normal" color="#518ede" @click="showExtract" :square="true" :block="true">下一步</van-button>
        </div>

        <div v-if="showModel==='modelExtractInfo'">
            <van-cell-group title="社保退休信息">
                <van-cell v-for="(item, index) in extractinfoList[0]"
                          :key="index"
                          :title="item.title"
                          :value="item.info"
                />
            </van-cell-group>
            <van-cell-group title="提取业务及结算信息">
                <van-cell v-for="(item, index) in extractinfoList[1]"
                          :key="index"
                          :title="item.title"
                          :value="item.info"
                />
            </van-cell-group>
            <div class="btn-wrap">
                <van-button type="default" size="normal" :square="true" :block="true" color="#666666" @click="showBaseinfo">上一步</van-button>
                <van-button type="default" size="normal" :square="true" :block="true" color="#518ede" @click="doVerifyFace()">下一步</van-button>
            </div>
        </div>

        <div v-show="showModel==='modelSubmit'">
            <van-cell-group title="业务办理身份认证">
                <van-cell title="中心预留手机号" :value="tel" />
                <van-field
                        v-model="msgCode"
                        type="number"
                        center
                        clearable
                        label="短信验证码"
                        placeholder="请输入短信验证码"
                        class="van-require-patch"
                        input-align="right"
                        maxlength="6"
                >
                    <van-button v-if="!isSend" slot="button" size="small" type="primary" @click="getMsgcode">发送验证码</van-button>
                    <van-button v-else slot="button" size="small" :disabled="true" color="#666666">重新发送{{countdown}}秒</van-button>
                </van-field>
                <!-- <van-field
                        v-model="pwd"
                        input-align="right"
                        type="password"
                        required
                        clearable
                        label="个人密码"
                        placeholder="请输入个人公积金密码"
                        maxlength="16"
                /> -->
            </van-cell-group>
            <van-button type="default" size="normal" color="#518ede" @click="doSubmit" :square="true" :block="true">提交</van-button>
        </div>

    </div>
</template>

<script>
    import {Cell, CellGroup, Button, Field,DatetimePicker} from 'vant';
    import 'vant/lib/cell/style';
    import 'vant/lib/cell-group/style';
    import 'vant/lib/button/style';
    import 'vant/lib/field/style';
    import 'vant/lib/datetime-picker/style';
    import uuidv1 from 'uuid/v1';

    Date.prototype.Format = function (fmt) {
      var o = {
        "M+": this.getMonth() + 1, // 月份
        "d+": this.getDate(), // 日
        "h+": this.getHours(), // 小时
        "m+": this.getMinutes(), // 分
        "s+": this.getSeconds(), // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
        "S": this.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    }
    export default {
        name: 'retirement',
        components: {
            vanCellGroup: CellGroup,
            vanCell: Cell,
            vanButton: Button,
            vanField: Field,
            vanDatetimePicker: DatetimePicker
        },
        mounted(){

        },
        data(){
            return {
                showModel:'',
                datalist: [],
                baseinfoList: [], // 第一页显示基本信息
                baseinfoList2: [], //第二段数据
                extractinfoList: [[],[]], //第二页显示提取信息
                pwd: '',
                tel: '',
                msgCode: '', //短信验证码
                countdown: 60,
                isSend: false,
            }
        },
        created(){
            // this.getBaseinfo();
            this.getBaseinfo();
            // this.doReport()
            this.tel = this.$store.state.zwUserInfo.tel || this.$store.state.btUserInfo.tel;
        },
        methods: {
            getSignUrl(){
              let self = this;

              sessionStorage.setItem("datalist",JSON.stringify(self.datalist));
              sessionStorage.setItem("baseinfoList",JSON.stringify(self.baseinfoList));
              sessionStorage.setItem("baseinfoList2",JSON.stringify(self.baseinfoList2));
              sessionStorage.setItem("extractinfoList",JSON.stringify(self.extractinfoList));
              sessionStorage.setItem("showModel",self.showModel);
              sessionStorage.setItem("pwd",self.pwd);
              sessionStorage.setItem("tel",self.tel);

              sessionStorage.setItem("jumpType","eleSign");
              // 拼接参数
              let HDDZ = encodeURIComponent(window.location.href);
              let personData = [];
              let zjhm = self.$store.state.btUserInfo.idCard || self.$store.state.zwUserInfo.zjhm;
              let xingming = self.$store.state.btUserInfo.userName || self.name;
              personData.push(xingming +"~" + zjhm + "~" +"01");
              let QZSJ = {
                personData:personData
              }

              self.$http.post('/miapp/H3003/mpaasgatewayunencrypted', {
                buztype: 5088, //定值
                JKLX:'scan',  //定值
                YWLXDM:'13',
                YWSSJGDM:'000000',  //定值
                YWBLJGDM:'000000',  //定值
                BLQD:'app', //定值
                YWLCJD:'0',//定值
                AJTM:xingming,
                YWRQ:new Date().Format("yyyyMMdd"),
                time:new Date().getTime(),
                YWLSH:uuidv1(),
                SFZH:zjhm,
                DWZH:'',
                GRXM:xingming,
                WJDM:'TQXYCNS',
                pdf_type:'TQXYCNS',
                QZSJ:QZSJ,
                HDDZ:HDDZ,
                ybmapMessage: {}
              }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                  window.location.replace(res.data);
                } else {
                  self.$utils.alert(res.msg);
                }
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            jumpSignAfter(){
              let self = this;
              let jumpType = sessionStorage.getItem("jumpType");
              sessionStorage.setItem("jumpType","");
              if(this.$route.query.iscallback == '1' && jumpType == 'eleSign'){
                //说明从ocr回来的，代表签字过了，直接调用提交接口
                self.datalist = JSON.parse(sessionStorage.getItem("datalist"));
                self.baseinfoList = JSON.parse(sessionStorage.getItem("baseinfoList"));
                self.baseinfoList2 = JSON.parse(sessionStorage.getItem("baseinfoList2"));
                self.extractinfoList = JSON.parse(sessionStorage.getItem("extractinfoList"));
                self.showModel = sessionStorage.getItem("showModel");
                self.pwd = sessionStorage.getItem("pwd");
                self.tel = sessionStorage.getItem("tel");

                sessionStorage.setItem("datalist","");
                sessionStorage.setItem("baseinfoList","");
                sessionStorage.setItem("baseinfoList2","");
                sessionStorage.setItem("extractinfoList","");
                sessionStorage.setItem("showModel","");
                sessionStorage.setItem("pwd","");
                sessionStorage.setItem("tel","");
              }
            },
            getBaseinfo(){
                let self = this;
                // self.$http.post('/miapp/A5110/mpaasgateway', { //政务接口
                self.$http.post('/miapp/A5010/mpaasgatewayunencrypted', {
                    // 江苏政务需要ticket
                    // ticket: self.$store.state.zwticket.zwticket ? self.$store.state.zwticket.zwticket : '',
                    // 江苏政务
                    /*ybmapMessage: {
                        grzh: self.$store.state.accountNumber.accountNumber,
                        zjhm: self.$store.state.zwUserInfo.idCard,
                        coreUserid: self.$store.state.zwUserInfo.coreUserid,
                        channel: '21'
                    }*/
                    ybmapMessage: {
                        grzh: self.$store.state.accountNumber.accountNumber,
                        zjhm: self.$store.state.btUserInfo.idCard,
                        coreUserid: self.$store.state.btUserInfo.coreUserid,
                        // channel: '21', //政务
                        channel: '11'
                    }
                }).then(res => {
                    self.$utils.loading(false);
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000'){
                        self.datalist = res.result;
                        let txbz = self.returnFieldValue(self.datalist,"txbz");
                        if(txbz == '0'){
                            self.getRetireCertificate();
                        }else{
                            self.showModel = 'modelBaseinfo';
                            this.jumpSignAfter();
                        }
                        self.baseinfoList = [
                            {title: '个人账号', info: self.$store.state.accountNumber.accountNumber, format: '0'},
                            /*{title: '证件类型', info: self.$store.state.btUserInfo.zjlx, format: '0'},*/
                            /*支付宝要信息脱敏，放开下面注释就可以*/
                            /*{title: '姓名', info: window._hideInfo(self.$store.state.btUserInfo.userName, 0, 0, true), format: '0'},
                            {title: '证件号码', info: window._hideInfo(self.$store.state.btUserInfo.zjhm, 1, 1), format: '0'},
                            {title: '预留手机号', info: window._hideInfo(self.$store.state.btUserInfo.tel, 3, 4), format: '0'}*/
                        ];
                        if(txbz == '0') {
                            res.result.filter((item, index) => {
                              if (item.format === '1') self.baseinfoList2.push(item);
                              if (item.format === '2' && item.name !== 'txbznew') self.extractinfoList[0].push(item);
                              if (item.format === '3') self.extractinfoList[1].push(item);
                            });
                        }else{
                            res.result.filter((item, index) => {
                              if (item.format === '1') self.baseinfoList2.push(item);
                              if (item.format === '2') self.extractinfoList[0].push(item);
                              if (item.format === '3') self.extractinfoList[1].push(item);
                            });
                        }
                    } else {
                        self.$utils.alert(res.msg, function(){
                            self.$router.go(-1);
                        });
                    }
                }).catch(res => {
                    self.$utils.loading(false);
                    console.log("error", res);
                });
            },
            getRetireCertificate(){
              let self = this;
              self.$http.post('/miapp/H4001/mpaasgatewayunencrypted', {
                ybmapMessage: {
                  zjhm: self.$store.state.btUserInfo.idCard,
                  channel: '11'
                }
              }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                  if(res.count == '' || res.count == null || res.count == undefined || res.count == '0'){
                    self.$utils.alert("您好！未查询到您的退休信息，如果您已退休，请携带相关证明至我中心窗口办理！")
                  }else{
                    self.showModel = 'modelBaseinfo';
                    this.jumpSignAfter();
                  }
                } else {
                  self.$utils.alert(res.msg)
                }
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            showExtract(){
                this.showModel = 'modelExtractInfo';
            },
            showBaseinfo(){
                this.showModel = 'modelBaseinfo';
            },
            doVerifyFace(){
                let self = this;
                //测试用
                this.showModel = 'modelSubmit';
                this.getSignUrl();
                return false;
                //测试用  结束

                if(!!lightAppJssdk){
                    // 江苏政务刷脸
                    lightAppJssdk.face.face({
                        idnum: self.$store.state.zwUserInfo.idCard,//身份证号
                        name: self.$store.state.zwUserInfo.userName,//真实姓名
                        success:function(data){
                            this.showModel = 'modelSubmit';
                        },
                        fail:function(data){
                            self.$utils.alert(data.msg);
                        }
                    });
                } else {
                    // 百通刷脸，待测试
                    // 百通先不加刷脸，刷脸成功后执行↓
                    this.showModel = 'modelSubmit';
                }
            },
            checkPwd(){
                let self = this;
                self.pwd = self.pwd.replace(/[^0-9]/g,'');
                if(self.pwd.length > 6) {
                    self.pwd = self.pwd.slice(0, 6);
                    self.$utils.alert('个人密码为6位数字');
                    return false;
                }
            },
            // 获取短信验证码
            getMsgcode(){
                let self = this;
                self.$http.post('/miapp/A5009/mpaasgatewayunencrypted', {
                    buztype: 5088,
                    xingming: encodeURI(self.$store.state.btUserInfo.userName) || encodeURI(self.name),
                    ybmapMessage: {
                        sjhm: self.tel,
                        zjhm: self.idCard || this.$store.state.btUserInfo.zjhm,
	                    xingming: self.$store.state.btUserInfo.userName || self.name,
                    }
                }).then(res => {
                    self.$utils.loading(false);
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000'){
                        let _checkCount = function _checkCount() {
                            //验证码倒计时
                            if (self.countdown === 0) {
                                self.isSend = false;
                                self.countdown = 60;
                                return;
                            } else {
                                self.isSend = true;
                                self.countdown--;
                            }
                            setTimeout(function () {
                                _checkCount();
                            }, 1000);
                        };
                        _checkCount();
                    } else {
                        self.$utils.alert(res.msg);
                    }
                }).catch(res => {
                    self.$utils.loading(false);
                    console.log("error", res);
                });
            },
            doSubmit(){
                let self = this;
               
                // if(self.pwd.length < 8 || self.pwd.length > 16){
                //     self.$utils.alert('个人密码为8-16位之间');
                //     return false;
                // }
                if(self.msgCode.length !== 6){
                    self.$utils.alert('短信验证码为6位数字');
                    return false;
                }
                // self.$http.post('/miapp/A5111/mpaasgateway', { //政务
                self.$http.post('/miapp/A5011/mpaasgatewayunencrypted', {
                    // ticket: self.$store.state.zwticket.zwticket ? self.$store.state.zwticket.zwticket : '',
                    ybmapMessage: {
                        dwzh: self.$store.state.btUserInfo.dwzh,
                        coreUserid: self.$store.state.btUserInfo.coreUserid,
                        sprq: new Date().getFullYear() + (new Date().getMonth()+1 < 10 ? '0'+(new Date().getMonth()+1) : new Date().getMonth()+1) + (new Date().getDate() < 10 ? '0'+new Date().getDate() : new Date().getDate()) , //录入日期 默认当天
                        // mima: self.pwd,
                        grzh: self.$store.state.accountNumber.accountNumber,
                        cllx: '71',
                        sjhm: self.$store.state.btUserInfo.tel,
                        hjny: self.returnFieldValue(self.datalist, 'hjny'),
                        zqorgcode: self.returnFieldValue(self.datalist, 'zqorgcode'),
                        zqocid: self.returnFieldValue(self.datalist, 'zqocid'),
                        skrmc: self.returnFieldValue(self.datalist, 'skrmc'),
                        skryh: self.returnFieldValue(self.datalist, 'skryh'),
                        skrzh: self.returnFieldValue(self.datalist, 'skrzh'),
                        hjstatus: self.returnFieldValue(self.datalist, 'hjstatus'),
                        je: self.returnFieldValue(self.datalist, 'gjjje'),
                        btje: self.returnFieldValue(self.datalist, 'btje'),
                        gjjye: self.returnFieldValue(self.datalist, 'gjjje'),
                        btye: self.returnFieldValue(self.datalist, 'btje'),
                        yzm: self.msgCode
                    },
                    money: self.returnFieldValue(self.datalist, 'tqze')
                    // money: '21'
                }).then(res => {
                    self.$utils.loading(false);
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000'){
                        self.$utils.alert('提交成功！中心将在1个工作日内办结。', function(){
                            // self.routingTo('');
                        })
                        self.doReport();
                    } else {
                        self.$utils.alert(res.msg);
                    }
                }).catch(res => {
                    self.$utils.loading(false);
                    console.log("error", res);
                });
            },
            doReport(){
                let self = this;
                console.log('baitong', self.$store.state.baitong);
                self.$http.post('/miapp/C0001/mpaasgatewayunencrypted', {
                    "accessToken": self.$store.state.baitong.userAccessToken,
                    "openId": self.$store.state.btUserInfo.openId,
                    "idCard": self.$store.state.btUserInfo.idCard,
                    "reportedData": {
                        "serviceId": "退休销户提取",
                        "ywName": "退休销户提取",
                        "statusNo": "1",
                        "eventName": "退休销户提取提交",
                        "orderId": self.$store.state.btUserInfo.idCard + Date.parse(new Date()),
                        "remark": "",
                        "detailInfo": {
                            "APPLICANT_NAME": self.$store.state.btUserInfo.userName,
                            "APPLY_DATE": new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," "),
                            "ORG_NAME": "南通市住房公积金中心",
                            "process": [
                                {
                                    "END_TIME": new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," "),
                                    "EVENT_NAME": "退休销户提取",
                                    "START_NOTE": "通过",
                                    "START_TIME": new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," "),
                                    "START_USER_NAME": "南通市住房公积金中心"
                                }
                            ],
                            "statuNO": "1",
                            "smtApplyFile":[]
                        }
                    }
                }, {loading: false}).then(res => {
                    self.$utils.loading(false);
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000'){

                    } else {
                        self.$utils.alert(res.msg || '业务上报失败');
                    }
                }).catch(res => {
                    self.$utils.loading(false);
                    console.log("error", res);
                });
            },
            returnFieldValue(data, name){
                return data.filter(function(item, index){
                    if(item.name === name){
                        return item.info;
                    }
                })[0].info;
            },
            routingTo(target){
                let self = this;
                self.$router.push({
                    path: '/' + target,
                    query: {
                        'openweb': 'paschybrid'
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .van-cell:not(:last-child)::after
        left 0
    .blank
        height .2rem
        display block
    .van-cell-group__title
        color #518ede
        font-weight 400
    .btn-wrap
        display flex
    .van-button--normal
        margin .3rem auto .2rem
</style>